import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import Variant from "./Variant";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class SectionItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const { gnObject, isChild } = this.props;
    return (
      <Col
        xs="12"
        md={isChild ? "12" : "6"}
        style={isChild ? { padding: 0 } : {}}
      >
        <Card>
          <CardHeader>Section</CardHeader>
          <CardBody>
            <h5>Business: {gnObject.business.name}</h5>
            <h6>ID: {gnObject.business.id}</h6>
            <hr />
            <h5>{gnObject.name}</h5>
            {!gnObject.image.isDefault && (
              <img
                style={{ width: "50%" }}
                src={`${CLOUDINARY_SHARE}/${gnObject.image.image.cloudinaryId}`}
              />
            )}{" "}
            <br />
            <a
              href={`${APP_BASE_URL}/place/${gnObject.business.slug}/items/${
                gnObject.id
              }`}
              target="__blank"
              rel="noopener noreferrer"
            >
              Visit Section
            </a>
            <p>{gnObject.description}</p>
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default SectionItem;



// WEBPACK FOOTER //
// ./src/views/Components/SectionItem.js